<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="title">
    <b-form @submit.prevent="onSubmit">

      <LgFinderPageContaContabil v-model="form.contaContabil" :error="$v.form.contaContabil" :prefix="updatedPrefix"
        id="finderPageConta Contabil" label="Conta Contabil: *" invalidFeedback="Conta Contabil deve ser informada!"
        cols="12" />
      <b-form-group label="Vida Útil (anos): *" label-for="vida-util">
        <b-form-input id="vida-util" v-model="form.vidaUtil" type="number" required></b-form-input>
      </b-form-group>

      <b-form-group label="Valor Residual (%): *" label-for="valor-residual">
        <b-form-input id="valor-residual" v-model="form.valorResidual" type="number" required></b-form-input>
      </b-form-group>

      <div class="d-flex justify-content-center mt-3">
        <b-button id="salvarConfigurar" type="submit" variant="success" style="height: 30px" pill size="sm">
          <div class="btn-size-alinhamento">
            <b-icon icon="check-circle" />
          </div>
          <b-tooltip target="salvarConfigurar" title="Salvar"></b-tooltip>

        </b-button>
        <b-button id="cancelarConfigurar" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
          variant="danger">
          <div class="btn-size-alinhamento">
            <b-icon icon="x-circle" />
          </div>
          <b-tooltip target="cancelarConfigurar" title="Cancelar"></b-tooltip>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import { FormResourceMixin } from "@/core/mixins/resource"
import { required } from "vuelidate/lib/validators"
import LgFinderPageContaContabil from "@/components/Finders/LgFinderPageContaContabil.vue"

export default {
  components: {
    LgFinderPageContaContabil,
  },
  props: {
    prefix: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  validations: {
    form: {
      descricao: { required },
      situacao: { required },
      contaContabil: { required },
    },
  },

  mixins: [FormResourceMixin],
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Configuração de Depreciação"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/natureza-despesa`)
    if (this.id) {
      const { data } = await this.$service.findById(this.id)
      this.form = data
    }
  },
  data() {
    return {
      showModal: true,
      form: {
        contaContabil: {},
        vidaUtil: "",
        valorResidual: "",
      },
    }
  },
  methods: {
    async onSubmit() {

      if (!this.formIsValid) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        })
        return
      }


      try {
        await this.$saveResource(this.form, "", true,
          {},
          this.isModal)
        this.cancelar()
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Ocorreu um erro ao salvar o cadastro.",
        })
      }


    },
    cancelar() {
      this.$emit("close")
    },
  },
}
</script>
